import { useSelector } from 'react-redux';
import * as ContactFieldService from 'services/contact_field';

export const useContactFieldService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchContactFields = async (options = {}) => {
    const { error, payload } = await ContactFieldService.read({ ...options, token });
    if (error) return { fields: [] };
    const fields = payload?.data ?? payload ?? [];
    return { fields };
  };

  return { fetchContactFields };
};
